import lazyLoading from '../../lazyLoading'

export default [
    {
        path: 'seconda',
        meta: {
            title: '二级页面a',
        },
        redirect: 'seconda/thirda',
        component: lazyLoading('views/pages/secondHasThird'),
        children: [
            {
                path: 'thirda',
                meta: {
                    title: '三级页面a'
                },
                component: lazyLoading('views/pages/third'),
            },
            {
                path: 'thirdb',
                meta: {
                    title: '三级页面b'
                },
                component: lazyLoading('views/pages/third'),
            },
            {
                path: 'thirdc',
                meta: {
                    title: '三级页面c'
                },
                component: lazyLoading('views/pages/third'),
            },
        ]
    },
    {
        path: 'secondb',
        meta: {
            title: '二级页面b',
        },
        component: lazyLoading('views/pages/second')
    },
    {
        path: 'secondc',
        meta: {
            title: '二级页面c',
        },
        component: lazyLoading('views/pages/second')
    }
]